import store from '@/store'

/**
 * 定义全局按钮权限指令
 * @returns 是否有权限
 */
export default function hasPermission() {
  return {
    mounted(el, binding) {
      const permission = store.getters.getPermissions
      const { value } = binding
      const hasPermissions = permission.some(permission => {
        return value.includes(permission)
      })
      if (!hasPermissions) {
        el.style.display = 'none'
      }
    }
  }
}
